import React, { useState, useRef } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { RiLoader4Line } from 'react-icons/ri';
import { useHistory } from 'react-router-dom'
import http from '../../../services/Api';
import SuccessModal from './SuccessModal';

import './index.css';
import { useForm } from 'react-hook-form';
import { ModalManager } from 'react-dynamic-modal/lib/Modal';

function RegisterEnterpriseForm() {
    const [loading, setLoading] = useState(false)
    const { register, handleSubmit, errors, watch } = useForm();
    const password = useRef({});

    password.current = watch("password", "");

    function openSuccessModal(username, password) {
        ModalManager.open(<SuccessModal username={username} password={password} />)
    }
    const save = async data => {
        const { name, password, email }
            = data;
        setLoading(true)

        try {
            let username = name.toLowerCase().split(' ').splice(0, 1).join('.') + ('.adm');

            await http.post(`/api/client/create/`, {
                client: {
                    name: name
                },
                user: {
                    name: username,
                    username: username,
                    email: email,
                    password: password,
                    userType: "60846a923c0c98d2837f2e42",
                    available_devices: [],
                    disabled: false,
                    verified: true,
                }
            });
            openSuccessModal(username, password);
            setLoading(false)
        } catch (e) {
            console.log(e)
            setLoading(false);
        }
    }

    return (
        <div className="RegisterUser-Form">
            <h1>Cadastro de empresa</h1>
            <Form method="POST" onSubmit={handleSubmit(save)}>
                <Form.Group as={Row}>
                    <Form.Label column sm="2">
                        Nome *
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control
                            type="text"
                            name="name"
                            ref={register}
                            placeholder="Digite o nome da empresa"
                        />
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column sm="2">
                        Email *
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control
                            type="Email"
                            name="email"
                            ref={register}
                            placeholder="Digite seu email"
                        />
                    </Col>
                </Form.Group>
                <Form.Group name="password" controlId="password" as={Row}>
                    <Form.Label column sm="2">
                        Senha*
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control
                            name="password"
                            placeholder="Digite a senha do Administrador"
                            type="password"
                            ref={register({
                                required: "Você deve escolher uma senha",
                                minLength: {
                                    value: 8,
                                    message: "A senha deve ter no mínimo 8 caracteres"
                                },
                                pattern: {
                                    value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i,
                                    message: "A senha deve conter ao menos um caractere maiúsculo e um caractere especial"
                                }
                            })} />
                        <span className="form-error-register">
                            {errors.password && <p>{errors.password.message}</p>}
                        </span>
                    </Col>
                </Form.Group>
                <Form.Group controlId="confirmPassword" as={Row}>
                    <Form.Label column sm="2">
                        Confirmar Senha *
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control
                            name="password_repeat"
                            type="password"
                            placeholder="Confirme a senha do Administrador"
                            ref={register({
                                validate: value =>
                                    value === password.current || "As senhas devem ser iguais"
                            })} />
                        <span className="form-error-register">
                            {errors.password_repeat && <p>{errors.password_repeat.message}</p>}
                        </span>
                    </Col>
                </Form.Group>
                <Button variant="primary" type="submit">
                    {loading ?
                        <RiLoader4Line className="spin" />
                        :
                        'Salvar'
                    }
                </Button>
            </Form>
        </div>
    );
}

export default RegisterEnterpriseForm;